"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilsHelper = void 0;
var json2csv_1 = require("json2csv");
/**
 * Utility methods to be used by other clients
 *
 * @private
 * */
var UtilsHelper = /** @class */ (function () {
    function UtilsHelper() {
    }
    UtilsHelper.quote = function (value) {
        return "\"".concat(value, "\"");
    };
    UtilsHelper.encapsulate = function (value) {
        return "'".concat(value, "'");
    };
    UtilsHelper.quoteArray = function (values) {
        var _this = this;
        var join = values.map(function (value) { return _this.quote(value); }).join(',');
        return "[".concat(join, "]");
    };
    UtilsHelper.convertToCsv = function (data, fields) {
        return new json2csv_1.Parser().parse({ data: data, fields: fields, hasCSVColumnTitle: false });
    };
    UtilsHelper.uniqueList = function (values) {
        var unique = new Set(values);
        return Array.from(unique);
    };
    return UtilsHelper;
}());
exports.UtilsHelper = UtilsHelper;
